(function() {
	'use strict';

	angular.module('masterApp').controller('PermissionAccessController',
			PermissionAccessController);

	PermissionAccessController.$inject = [ '$scope', '$state', 'NgTableParams',
			'PermissionAccessService' ];

	function PermissionAccessController($scope, $state, NgTableParams,
			PermissionAccessService) {
		var vm = this;
		var self = $scope;

		vm.param = {};
		vm.getUser = function() {
			PermissionAccessService.query({
				uri : 'getUser'
			}, function(result) {
				vm.listUser = result;
				if (result != null && result.length > 0) {
					vm.user = result[0];
					vm.permissionTable.page(1);
					vm.permissionTable.count(20);
					vm.permissionTable.total(0);
					vm.permissionTable.reload();
				}
			}, function(excep) {
			});
		};

		/*vm.loadOffice = function() {
			PermissionAccessService.query({
				uri : 'getOffice',
				userName : vm.user
			}, function(result) {
				vm.listOffice = result;
				if (result != null && result.length > 0) {
					vm.office = result[0].code;
					vm.loadStock();
				}
			}, function(excep) {
			});
		};

		vm.loadStock = function() {
			PermissionAccessService.query({
				uri : 'getStock',
				userName : vm.user,
				officeCode : vm.office
			}, function(result) {
				vm.listStock = result;
				if (result != null && result.length > 0) {
					vm.stock = result[0].code;
					vm.permissionTable.page(1);
					vm.permissionTable.count(20);
					vm.permissionTable.total(0);
					vm.permissionTable.reload();
				}
			}, function(excep) {
			});
		};*/

		vm.init = function() {
			vm.getUser();
		};

		vm.permissionTable = new NgTableParams(
				{
					page : 1,
					count : 20
				},
				{
					total : 0,
					counts : [],
					defaultSort : 'desc',
					getData : function(params) {
						vm.param.uri = "getPermission";
						if (vm.user != undefined && vm.user != null) {
							vm.param.userName = vm.user;
							/*vm.param.office = vm.office;
							vm.param.stockCode = vm.stock;*/
							return PermissionAccessService.query(vm.param).$promise
									.then(function(result) {
										if (vm.listPermissionAccess != null
												&& vm.listPermissionAccess.length > 0) {
											var isExist = false;
											vm.listTemp = [];
											for (var i = 0, size = vm.listPermissionAccess.length; i < size; i++) {
												var obj = vm.listPermissionAccess[i];
												if (obj.username == vm.user
														/*&& obj.officeCode == vm.office
														&& obj.stockCode == vm.stock*/) {
													vm.listTemp.push(obj);
													isExist = true;
												}
											}
											if (!isExist) {
												for (var i = 0, size = result.length; i < size; i++) {
													vm
															.createObj(
																	result[i].check,
																	result[i].permissionCode);
												}
												return result;
											}
											return vm.listTemp;
										} else {
											for (var i = 0, size = result.length; i < size; i++) {
												vm.createObj(
														result[i].check,
														result[i].permissionCode);
											}
											return vm.listPermissionAccess;
										}
									});
						}
					}
				});

		vm.listPermissionAccess = [];

		vm.choose = function(item) {
			if (vm.listPermissionAccess != null
					&& vm.listPermissionAccess.length > 0) {
				var existed = -1;
				for (var i = 0, size = vm.listPermissionAccess.length; i < size; i++) {
					var obj = vm.listPermissionAccess[i];
					if (obj.username == item.username
							&& obj.permissionCode == item.permissionCode) {
						existed = i;
						break;
					}
				}
				if (existed == -1) {
					vm.createObj(true, item.permissionCode);
				} else {
					vm.listPermissionAccess[existed].check = item.check;
				}
			}
		};

		vm.createObj = function(check, permissionCode) {
			var obj = {};
			obj.username = vm.user;
			/*obj.officeCode = vm.office;
			obj.stockCode = vm.stock;*/
			obj.check = check;
			obj.permissionCode = permissionCode;
			vm.listPermissionAccess.push(obj);
		};

		vm.save = function() {
			self.loading = true;
			PermissionAccessService.post({
				uri : 'savePermissionAccess'
			}, vm.listPermissionAccess, function(result) {
				$(window).scrollTop(0);
				self.loading = false;
				if (result.messages.length == 0) {
					self.addAlert('Thao tác thành công!', 'success');
				}
			}, function() {
				self.loading = false;
			});
		};
		
		vm.loadPermission = function() {
			vm.permissionTable.page(1);
			vm.permissionTable.count(20);
			vm.permissionTable.total(0);
			vm.permissionTable.reload();
		};
	}
})();
